import React, { useState, useRef, useEffect } from 'react'
import cn from 'classnames'
import { get, map, debounce, head, values, each } from 'lodash'

import styles from './CategoryBar.module.scss'
import dropDownStyles from './DropDown.module.scss'
import QuickMenuSearch from '../containers/QuickMenuSearch'
import CategoryPill from './CategoryPill'
import Button from './Button'

import { ReactComponent as UpArrow } from '../assets/icons/chevronUp.svg'
import { ReactComponent as DownArrow } from '../assets/icons/chevronDown.svg'

const CategoryBar = ({ className, menuItems, itemCategories, setSelectedCategory, selectedCategory, setHighlightedIds }) => {
  const classNames = cn(styles.CategoryBar, className)
  const classNamesDropDown = cn(dropDownStyles.dropDown, className)
  const [quickSearchFlag, setQuickSearchFlag] = useState(false)
  const [showModal, toggleModal] = useState(false)
  const [scrollIntervals, setScrollIntervals] = useState([])
  const quickSearchRef = useRef()
  const categorySliderRef = useRef()

  let showSliderArrows = categorySliderRef.current && categorySliderRef.current.offsetWidth < categorySliderRef.current.scrollWidth - 10
  const SCROLL_FORWARD = 250
  const SCROLL_BACK = -250
  const SCROLL_FORWARD_HOLD = 40
  const SCROLL_BACK_HOLD = -40

  const renderQuickSearch = () => {
    if (quickSearchFlag) {
      const focus = get(quickSearchRef, 'current.focus', () => {}).bind(get(quickSearchRef, 'current', () => {}))
      focus()
    } else {
      setQuickSearchFlag(true)
    }
  }

  const enableSelectedCategory = (categoryUuid) => {
    if (quickSearchFlag) {
      setQuickSearchFlag(false)
      setHighlightedIds({query: '', highlightedIds: [], focusedItemId: undefined})
    }
    if (categoryUuid === selectedCategory.id) {
      setSelectedCategory({ id: '', search: false, highlight: false })
    } else {
      setSelectedCategory({ id: categoryUuid, search: true, highlight: true })
    }
    if (showModal) {
      toggleModal(false)
    }
  }

  const scrollTap = (scrollValue) => {
    categorySliderRef?.current?.scrollBy(scrollValue, 0)
  }

  const scrollHoldInterval = (scrollValue) => {
    const startScrolling = debounce(() => {
      categorySliderRef?.current?.scrollBy(scrollValue, 0)
    }, 10)
    const scrollInterval = setInterval(startScrolling, 70)
    setScrollIntervals([...scrollIntervals, scrollInterval])
  }
  const endScrollIntervals = () => {
    if (scrollIntervals.length) {
      each(scrollIntervals, (scrollInterval) => clearInterval(scrollInterval))
      setScrollIntervals([])
    }
  }

  const chevron = <svg height="24" width="24" >
  <polygon points="3,18 12,9 21,18 22,16 12,6 3,15" fill="#FFF" />
  </svg>

  const searchIcon = <svg width="24" height="26"><g strokeWidth="3" stroke="#FFF" fill="none"><path d="M22.29 22.71l-6-6"/><circle cx="10" cy="10" r="8"/></g></svg>

  const quickMenuSearch = quickSearchFlag ? <QuickMenuSearch menuItems={menuItems} setQuickSearchFlag={setQuickSearchFlag} quickSearchRef={quickSearchRef} /> : null

  useEffect(() => {
    if (!selectedCategory?.id) {
      setSelectedCategory({ id: head(values(itemCategories))?.itemCategoryUuid, search: false, highlight: false })
    }
  }, [])

  useEffect(() => {
    return () => {
      each(scrollIntervals, (scrollInterval) => clearInterval(scrollInterval))
    }
  }, [scrollIntervals])

  let modalElement = null

  if (showModal) modalElement = (
    <div className={dropDownStyles.menuSelectOverlay}>
      <div className={dropDownStyles.menuSelectModal}>
        <div
          className={dropDownStyles.modalHeader}
          onClick={() => toggleModal(!showModal)}
        >
          <div className={dropDownStyles.currentSelectedMenu}>
            {itemCategories?.[selectedCategory?.id]?.name}
          </div>
          <div className={dropDownStyles.arrow}><UpArrow /></div>
        </div>
        {map(itemCategories, category =>
          category.itemCategoryUuid !== selectedCategory?.id ? (
            <div
              key={category.itemCategoryUuid}
              className={dropDownStyles.menuSelect}
              onClick={() => enableSelectedCategory(category.itemCategoryUuid)}
            >
              {category.name}
            </div>
          ) : null
        )}
      </div>
    </div>
  )

  const categoryDropDown = (
    <div className={classNamesDropDown}>
        {modalElement}
        <div className={dropDownStyles.titleHeader} onClick={() => toggleModal(!showModal)}>
          <span className={dropDownStyles.name}>{itemCategories?.[selectedCategory?.id]?.name}</span>
          <div className={dropDownStyles.arrow}><DownArrow /></div>
        </div>
    </div>
  )


  const categoryBar = (
    <div className={classNames}>
      <div className={styles.categorySlider}>
        { showSliderArrows ? <Button className={styles.shiftLeft} onClick={() => scrollTap(SCROLL_BACK)} onTouchStart={() => scrollHoldInterval(SCROLL_BACK_HOLD)} onTouchEnd={() => endScrollIntervals()}><div className={styles.chevronL}>{chevron}</div></Button> : null }
        <div className={styles.categoryPills} ref={categorySliderRef}>
          {map(itemCategories, category => (
            <CategoryPill
              className={className}
              category={category}
              selectedCategory={selectedCategory}
              setCategory={enableSelectedCategory}
              key={category.itemCategoryUuid}
            />
          ))}
        </div>
        { showSliderArrows ? <Button className={styles.shiftRight}  onClick={() => scrollTap(SCROLL_FORWARD)} onTouchStart={() => scrollHoldInterval(SCROLL_FORWARD_HOLD)} onTouchEnd={() =>  endScrollIntervals()}> <div className={styles.chevronR}>{chevron}</div></Button> : null }
      </div>
      <Button className={styles.quickSearchButton} onClick={() => renderQuickSearch()}> {searchIcon} </Button>
      {quickMenuSearch}
    </div>
  )

  return document?.body?.clientWidth > 800 ? categoryBar : categoryDropDown
}

export default CategoryBar
